/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import type { IErrorResponse, ProductGroup } from '@/types';

import { useQuery } from '@tanstack/react-query';

import { urls } from '@/statics';

const useProductGroup = ({ code }: { code: number | null }) =>
  useQuery<ProductGroup, IErrorResponse>({
    queryKey: [urls.productGroup(code || 0)],
    enabled: Boolean(code),
  });

export default useProductGroup;
